"use client";
import * as React from "react";

type InputProps = {
  type?: "text" | "number" | "email" | "url";
  id: string;
  label: string;
  value: string;
  classNames?: {
    input?: string;
    label?: string;
    container?: string;
  };
  handleInputChange?: (e: any) => void;
} & JSX.InputHTMLAttributes<HTMLInputElement>;
import styles from "../index.module.css";
import Spacer from "../../Spacer/index";
import cssClassAssembler from "../../../sso/utils/cssClassAssembler";

function InputField(props: InputProps) {
  function inputHTMLAttributes() {
    const { type, id, label, value, classNames, handleInputChange, ...rest } =
      props;
    return rest;
  }

  function cssClass() {
    return {
      container: cssClassAssembler(
        props.classNames?.container,
        styles.container
      ),
      input: cssClassAssembler(props.classNames?.input, styles.input),
      label: cssClassAssembler(props.classNames?.label, styles.label),
    };
  }

  return (
    <div className={cssClass().container}>
      <label htmlFor={props.id} className={cssClass().label}>
        {props.label}
      </label>
      <Spacer y={2} />
      <input
        type={props.type || "text"}
        id={props.id}
        value={props.value}
        className={cssClass().input}
        onChange={(event) =>
          typeof props.handleInputChange === "function" &&
          props.handleInputChange(event)
        }
        {...inputHTMLAttributes()}
      />
    </div>
  );
}

export default InputField;
